
angular.module('dyb.util.models', [
        'dyb.util.dates',
        'dyb.util.constants']);
